import PersonIcon from "@mui/icons-material/Person";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { Button, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isUserAuthorizedByServer } from "../api/userAccess";
import PageLoading from "../components/PageLoading";
import { selectUserSession } from "../slices/userSession/userSessionSlice";
import { logout } from "../util/authentication";
import { ACCESS_REQUIREMENTS, MULTI_STATION_ADMIN_ACCESS } from "../util/constants";
import { getWorkgroupGivenJobCode } from "../util/workgroupMapper";

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
  },
  pageTitle: {
    [theme.breakpoints.down("lg")]: {
      margin: "auto",
      marginTop: "20px",
      marginLeft: "15px",
      fontSize: "20px",
    },
    fontSize: "32px",
    marginTop: "10px",
    marginLeft: "75px",
    textAlign: "left",
    color: theme.palette.primary.swaBlue,
  },
  quickLinksButtonGroup: {
    [theme.breakpoints.down("md")]: {
      margin: "auto",
    },
    display: "flex",
    justifyContent: "left",
    marginLeft: "75px",
    width: "100%",
    flexWrap: "wrap",
    color: theme.palette.secondary.swaWhite,
  },
  quickLinksButton: {
    [theme.breakpoints.down("md")]: {
      height: "36px",
      minWidth: "95vw",
      margin: "auto",
      marginTop: "5px",
      marginBottom: "5px",
    },
    width: "250px",
    height: "50px",
    color: theme.palette.secondary.swaWhite,
    fontSize: "14px",
    margin: "10px",
    paddingLeft: "40px",
    paddingRight: "40px",
    lineHeight: "16px",
  },
  // quickLinksTitle: {
  //   [theme.breakpoints.down("sm")]: {
  //     margin: "auto",
  //     marginLeft: "15px",
  //   },
  //   color: theme.palette.secondary.swaBlack,
  //   float: "left",
  //   marginLeft: "75px",
  //   textAlign: "left",
  //   fontSize: "20px",
  //   fontWeight: "bold",
  // },
  yourInfo: {
    [theme.breakpoints.down("md")]: {
      minWidth: "95vw",
      margin: "auto",
    },
    width: "22vw",
  },
  yourInfoTitle: {
    [theme.breakpoints.down("md")]: {
      marginLeft: "10px",
      marginTop: "5px",
    },
    fontSize: "20px",
    textAlign: "left",
    marginTop: "10px",
    marginLeft: "15px",
    fontWeight: "bold",
  },
  yourInfoTable: {
    [theme.breakpoints.down("md")]: {
      minWidth: "87vw",
      margin: "auto",
    },
    margin: "auto",
    width: "19vw",
    fontSize: "16px",
  },
  yourInfoTableDivider: {
    width: "19vw",
  },
  leftColumn: {
    textAlign: "left",
  },
  rightColumn: {
    textAlign: "right",
  },
  quickLinksDivider: {
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "1%",
    marginRight: "1%",
  },
  buttonIcon: {
    position: "absolute",
    left: "10px",
  },
  superuserButtonIcon: {
    position: "absolute",
    left: "10px",
    color: theme.palette.primary.swaYellow,
  },
  toolTip: {
    fontSize: "12px",
    maxWidth: "200px",
    textAlign: "center",
  },
}));

const HomePageOld = (props) => {
  const classes = useStyles();
  const userSession = useSelector(selectUserSession);
  const [isUserAuthorizedState, setIsUserAuthorizedState] = useState(false);
  const [isUserAuthorizedStateLoading, setIsUserAuthorizedStateLoading] = useState(true);

  useEffect(() => {
    if (!isUserAuthorizedState) {
      isUserAuthorized();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorizedState]);

  const isUserAuthorized = () => {
    isUserAuthorizedByServer(userSession).then((is200) => {
      if (is200) {
        setIsUserAuthorizedState(true);
      } else {
        logout();
      }
      setIsUserAuthorizedStateLoading(false);
    });
  };
  const renderPageHeader = () => {
    return (
      <div>
        <Grid item xs={12}>
          <Typography component={"div"}>
            <Box className={classes.pageTitle}>{"Welcome, " + userSession.firstName + "!"}</Box>
          </Typography>
        </Grid>
        <Divider className="divider" />
      </div>
    );
  };

  const renderPageContent = () => {
    const quickLinksMenuList = () => {
      let quickLinks = [];
      const userMenuItems = props.userFeatures;
      if (props.isDesktopView) {
        userMenuItems.forEach((menuItem) => {
          if (menuItem.isHomeButton) {
            quickLinks.push(menuItem);
          } else {
            if (menuItem.childItems.length > 0) {
              menuItem.childItems.forEach((childItem) => {
                if (childItem.isHomeButton) {
                  quickLinks.push(childItem);
                }
              });
            }
          }
        });
      } else {
        userMenuItems.forEach((menuItem) => {
          if (menuItem.isActiveOnMobile) {
            if (menuItem.isHomeButton) {
              quickLinks.push(menuItem);
            } else {
              if (menuItem.childItems.length > 0) {
                menuItem.childItems.forEach((childItem) => {
                  if (childItem.isHomeButton && childItem.isActiveOnMobile) {
                    quickLinks.push(childItem);
                  }
                });
              }
            }
          }
        });
      }
      quickLinks.sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
      return quickLinks;
    };

    const renderPath = (item) => {
      let path = item.path;

      if (userSession.isAdmin && item.adminPath) {
        path = item.adminPath;
      }

      const mobileViewLinkChanges = ["timeOffRequest", "tradeForm"];

      if (!props.isDesktopView && mobileViewLinkChanges.indexOf(item.key) !== -1) {
        path = item.path;
      }

      return path;
    };

    const renderEmployeeQuickLinks = () => {
      return quickLinksMenuList().map((item, idx) => {
        if (
          !item.accessRequirements.includes(ACCESS_REQUIREMENTS.ADMIN) &&
          !item.accessRequirements.includes(ACCESS_REQUIREMENTS.SUPERUSER)
        ) {
          return (
            <Tooltip key={idx} title={item.description} arrow placement="bottom" classes={{ tooltip: classes.toolTip }}>
              <Button
                className={classes.quickLinksButton}
                href={`#${renderPath(item)}`}
                variant="contained"
                color="primary"
                size="large"
                aria-label="large contained primary button group"
              >
                <PersonIcon className={classes.buttonIcon} />
                {item.label}
              </Button>
            </Tooltip>
          );
        }
        return "";
      });
    };

    const renderAdminAndSuperuserQuickLinks = () => {
      return quickLinksMenuList().map((item, idx) => {
        if (item.accessRequirements.includes(ACCESS_REQUIREMENTS.ADMIN)) {
          return (
            <Tooltip key={idx} title={item.description} arrow placement="bottom" classes={{ tooltip: classes.toolTip }}>
              <Button
                className={classes.quickLinksButton}
                href={`#${renderPath(item)}`}
                variant="contained"
                color="primary"
                size="large"
                aria-label="large contained primary button group"
              >
                <SupervisorAccountIcon className={classes.buttonIcon} />
                {item.label}
              </Button>
            </Tooltip>
          );
        } else if (item.accessRequirements.includes(ACCESS_REQUIREMENTS.SUPERUSER)) {
          return (
            <Tooltip key={idx} title={item.description} arrow placement="bottom" classes={{ tooltip: classes.toolTip }}>
              <Button
                className={classes.quickLinksButton}
                href={`#${renderPath(item)}`}
                variant="contained"
                color="primary"
                size="large"
                aria-label="large contained primary button group"
              >
                <SupervisorAccountIcon className={classes.superuserButtonIcon} />
                {item.label}
              </Button>
            </Tooltip>
          );
        }
        return "";
      });
    };

    return (
      <Grid container className={classes.root}>
        <Grid item xs={12} sm={12} md={9}>
          <Grid container>
            <Grid item xs={12} className={classes.quickLinksButtonGroup}>
              {renderEmployeeQuickLinks()}
            </Grid>
            {(userSession.isAdmin || userSession.isSuperuser) && (
              <>
                <Grid item xs={12}>
                  <Divider className={classes.quickLinksDivider} />
                </Grid>
                <Grid item xs={12} className={classes.quickLinksButtonGroup}>
                  {renderAdminAndSuperuserQuickLinks()}
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Paper className={classes.yourInfo} variant="outlined">
            <div className={classes.yourInfoTitle}>My Info</div>
            <Grid container className={classes.yourInfoTable}>
              <Grid item xs={6} className={classes.leftColumn}>
                Name
              </Grid>
              <Grid item xs={6} className={classes.rightColumn}>
                {userSession.lastName}, {userSession.firstName}
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={6} className={classes.leftColumn}>
                Employee ID
              </Grid>
              <Grid item xs={6} className={classes.rightColumn}>
                {userSession.eid}
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={6} className={classes.leftColumn}>
                Home Station
              </Grid>
              <Grid item xs={6} className={classes.rightColumn}>
                {userSession.homeStation}
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>

              {userSession.tempStation && (
                <>
                  <Grid item xs={6} className={classes.leftColumn}>
                    Temp Station
                  </Grid>
                  <Grid item xs={6} className={classes.rightColumn}>
                    {userSession.tempStation}
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                </>
              )}

              <Grid item xs={6} className={classes.leftColumn}>
                Workgroup
              </Grid>
              <Grid item xs={6} className={classes.rightColumn}>
                {getWorkgroupGivenJobCode(userSession.jobCode)}
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={6} className={classes.leftColumn}>
                Job Code
              </Grid>
              <Grid item xs={6} className={classes.rightColumn}>
                {userSession.jobCode}
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={6} className={classes.leftColumn}>
                FT/PT
              </Grid>
              <Grid item xs={6} className={classes.rightColumn}>
                {userSession.isFTOrPT}
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={6} className={classes.leftColumn}>
                Access Level
              </Grid>
              <Grid item xs={6} className={classes.rightColumn}>
                {userSession.appRole}
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              {userSession.appRole === MULTI_STATION_ADMIN_ACCESS && (
                <>
                  <Grid item xs={6} className={classes.leftColumn}>
                    Admin Stations
                  </Grid>
                  <Grid item xs={6} className={classes.rightColumn}>
                    {userSession.multiStationAdminStationList.join(", ")}
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                </>
              )}
              {userSession.isSuperuser && (
                <>
                  <Grid item xs={6} className={classes.leftColumn}>
                    Superuser
                  </Grid>
                  <Grid item xs={6} className={classes.rightColumn}>
                    Yes
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={6} className={classes.leftColumn}>
                    Superuser Stations
                  </Grid>
                  <Grid item xs={6} className={classes.rightColumn}>
                    {userSession.superuserStationList.join(", ")}
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    );
  };

  return (
    <div className="App-contents enable-scroll" data-testid="home-page">
      {isUserAuthorizedStateLoading ? (
        <PageLoading />
      ) : (
        <div>
          {renderPageHeader()}
          {renderPageContent()}
        </div>
      )}
    </div>
  );
};

HomePageOld.propTypes = {
  userFeatures: PropTypes.array.isRequired,
  isDesktopView: PropTypes.bool.isRequired,
};

export default HomePageOld;
